import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { getKilogramsAndGramsFromGrams } from 'ui-components/components/weight-input/helpers';
import { getPoundsAndOuncesFromOunces } from 'ui-components/components/weight-input/ounces-weight-input';

import style from './edit-delivery-option-page.module.less';
import { DimensionUnit } from '../../../../../../enums/dimension-unit';
import { WeightUnit } from '../../../../../../enums/weight-unit';
import Global from '../../../../../../store/global-selectors';
import messages from '../../messages';

const INCH = 'in';
const CENTIMETER = 'cm';

export const WeightBreakpointReadOnly = ({ sellerDefaultDimensionUnit, weight, dimensions, index, arrayLength, prevWeight = 0 }) => {
  const isLast = index === arrayLength - 1;
  const rangeTitle = index === 0 ? messages.lowRangeTitle : messages.highRangeTitle;
  const defaultUnit = useSelector(Global.selectSellerDefaultWeightUnit);
  const displayWeightUnit = defaultUnit === WeightUnit.Ounces ? messages.startingWeightLB : messages.startingWeightKG;

  const convertedWeight = (weightToBeConverted) => {
    if (defaultUnit === WeightUnit.Ounces) {
      const convertedLBWeight = getPoundsAndOuncesFromOunces(weightToBeConverted);
      return {
        firstValue: convertedLBWeight.pounds,
        secondValue: convertedLBWeight.ounces,
      };
    }
    const convertedKGWeight = getKilogramsAndGramsFromGrams(weightToBeConverted);
    return {
      firstValue: convertedKGWeight.kilograms,
      secondValue: convertedKGWeight.grams,
    };
  };

  return (
    <>
      <div className={classnames(style['breakpoint-container'], style['read-only'])}>
        <FlexRow className={style['range-header-read-only']}>
          {index === 0 || isLast ? (
            <div className={style['header-text-read-only']}>
              <Text textType={TextType.H4} value={rangeTitle} />
            </div>
          ) : null}
          {!isLast && index !== 0 && <div className={style['empty-div']} />}
          <Text className={style['package-text']} textType={TextType.Paragraph} value={messages.packageDimensions} />
        </FlexRow>

        <div className={classnames(style['start-stop-container'], style['read-only'])}>
          <div className={style['weight-container']}>
            <FlexRow>
              <Text
                className={style['weight-text']}
                formattedMessageValues={convertedWeight(prevWeight)}
                textType={TextType.paragraph}
                value={displayWeightUnit}
              />
            </FlexRow>
            <div className={style.arrow}>
              <div className={style.line} />
              <div className={style.point} />
            </div>
            <FlexRow>
              {!isLast && (
                <Text
                  className={style['weight-text']}
                  formattedMessageValues={convertedWeight(weight)}
                  textType={TextType.paragraph}
                  value={displayWeightUnit}
                />
              )}
              {isLast ? <Text className={style['weight-text']} textType={TextType.paragraph} value={messages.andAbove} /> : null}
            </FlexRow>
          </div>
          <Text
            className={style['dim-label-read-only']}
            formattedMessageValues={{
              length: dimensions.length,
              width: dimensions.width,
              height: dimensions.height,
              unit: sellerDefaultDimensionUnit === DimensionUnit.Inches ? INCH : CENTIMETER,
            }}
            textType={TextType.paragraph}
            value={messages.readOnlyDims}
          />
        </div>
      </div>
    </>
  );
};

WeightBreakpointReadOnly.propTypes = {
  sellerDefaultDimensionUnit: PropTypes.string.isRequired,
  weight: PropTypes.number.isRequired,
  dimensions: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    length: PropTypes.number,
    unit: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
  arrayLength: PropTypes.number.isRequired,
  prevWeight: PropTypes.number,
};
